import { useGroupFunctions } from 'components/Dashboard/Influence/CrmGroups/GroupFunctions';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useGetContactById = () => {
  const { listingGroupsForStakeholderOrContact } = useGroupFunctions();
  const { generalApiCall } = useGeneralApiCall();

  const getContactById = async (id, source) => {
    let pathname = `/api/crm-contact/query`;
    const method = 'post';
    const requestProperties = {
      filters: [
        {
          field: 'id',
          operator: 'str_eq',
          value: id.toString(),
        },
      ],
      query: '',
      pageSize: 1,
      pageNumber: 1,
    };

    let callResults = await generalApiCall({
      pathname,
      method,
      requestProperties,
      needsAuthentication: true,
      requestSource: source,
      notShowErrorMessage: true,
    });

    let results = callResults?.hits;
    if (!!results.length) {
      let result = results[0];
      let groups = await listingGroupsForStakeholderOrContact({ contactId: result?.id });
      if (!!groups) {
        result = { ...result, groups };
      }
      return result;
    }
  };

  return { getContactById };
};

export default useGetContactById;
